export const usernameMinLength = 4;
export const usernameMaxLength = 75;

export const securePasswordMaxLength = 64;
export const securePasswordMinLength = 12;

export const commonPasswords = ["Buildertrend123", "123Buildertrend", "TheBobs12345"];
